var map = {
	"./fashi-1.png": 5947,
	"./longqishi-1.png": 6890,
	"./mo-1.png": 4509,
	"./qishi-1.png": 8796,
	"./ren-1.png": 383,
	"./yemanren-1.png": 3687,
	"./youxia-1.png": 1655,
	"./zhanxingshi-1.png": 1023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6983;